// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddTestsToStepController from "./add_tests_to_step_controller"
application.register("add-tests-to-step", AddTestsToStepController)

import AddressController from "./address_controller"
application.register("address", AddressController)

import CandidateJob__AddToJobController from "./candidate_job/add_to_job_controller"
application.register("candidate-job--add-to-job", CandidateJob__AddToJobController)

import CandidateJob__SendWhatsappController from "./candidate_job/send_whatsapp_controller"
application.register("candidate-job--send-whatsapp", CandidateJob__SendWhatsappController)

import CandidateJobBulkSelectorController from "./candidate_job_bulk_selector_controller"
application.register("candidate-job-bulk-selector", CandidateJobBulkSelectorController)

import CandidateJobFilterController from "./candidate_job_filter_controller"
application.register("candidate-job-filter", CandidateJobFilterController)

import CandidateJobSortableController from "./candidate_job_sortable_controller"
application.register("candidate-job-sortable", CandidateJobSortableController)

import CandidateJobSpinnerController from "./candidate_job_spinner_controller"
application.register("candidate-job-spinner", CandidateJobSpinnerController)

import CandidateJobsViewToggleController from "./candidate_jobs_view_toggle_controller"
application.register("candidate-jobs-view-toggle", CandidateJobsViewToggleController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import ColorController from "./color_controller"
application.register("color", ColorController)

import CombinedMentionsController from "./combined_mentions_controller"
application.register("combined-mentions", CombinedMentionsController)

import CopyButtonController from "./copy_button_controller"
application.register("copy-button", CopyButtonController)

import CreditCalculatorController from "./credit_calculator_controller"
application.register("credit-calculator", CreditCalculatorController)

import EmailCandidatesReceiversBulkController from "./email_candidates_receivers_bulk_controller"
application.register("email-candidates-receivers-bulk", EmailCandidatesReceiversBulkController)

import EmailVariableSelectorController from "./email_variable_selector_controller"
application.register("email-variable-selector", EmailVariableSelectorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InitializeCommonScriptController from "./initialize_common_script_controller"
application.register("initialize-common-script", InitializeCommonScriptController)

import JobColumnSortableController from "./job_column_sortable_controller"
application.register("job-column-sortable", JobColumnSortableController)

import JobDescriptionController from "./job_description_controller"
application.register("job-description", JobDescriptionController)

import JobPublicationController from "./job_publication_controller"
application.register("job-publication", JobPublicationController)

import KeyQuestionEditController from "./key_question_edit_controller"
application.register("key-question-edit", KeyQuestionEditController)

import KeyQuestionRemoveAllController from "./key_question_remove_all_controller"
application.register("key-question-remove-all", KeyQuestionRemoveAllController)

import KeyQuestionSortableController from "./key_question_sortable_controller"
application.register("key-question-sortable", KeyQuestionSortableController)

import LandingPageSectionActivationController from "./landing_page_section_activation_controller"
application.register("landing-page-section-activation", LandingPageSectionActivationController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PlansController from "./plans_controller"
application.register("plans", PlansController)

import RefineWithAiController from "./refine_with_ai_controller"
application.register("refine-with-ai", RefineWithAiController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import StepSortableController from "./step_sortable_controller"
application.register("step-sortable", StepSortableController)

import TestsSearchController from "./tests_search_controller"
application.register("tests-search", TestsSearchController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import UnsavedDataController from "./unsaved_data_controller"
application.register("unsaved-data", UnsavedDataController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import ProfileSourceFormController from "./profile_source_form_controller"
application.register("profile-source-form", ProfileSourceFormController)
console.log("ProfileSourceForm controller registered")

import JobPersonaController from "./job_persona_controller"
application.register("job-persona", JobPersonaController)

import ProcessOwnerFilterController from "./process_owner_filter_controller"
application.register("process-owner-filter", ProcessOwnerFilterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
